import type { FluidVariantId } from './sim/fluidSim.js';
import type { WaveVariantId } from './sim/waveSim.js';

/** The live screen, small charging chip and theme previews use one mapping. */
export function resolveEnergySim(
  code: string,
  mode: 'light' | 'dark'
): { kind: 'fluid'; variant: FluidVariantId } | { kind: 'wave'; variant: WaveVariantId } | null {
  if (code === 'cartographic') return { kind: 'fluid', variant: `fluid-cartographic-${mode}` };
  if (code === 'skin_midnight') return { kind: 'fluid', variant: `fluid-midnight-${mode}` };
  if (code === 'skin_sunset') return { kind: 'wave', variant: `wave-sunset-${mode}` };
  if (code === 'skin_bloom') return { kind: 'wave', variant: `wave-bloom-${mode}` };
  return null;
}
